__turbopack_context__.v({
  "button": "LmMEBq_button",
  "container": "LmMEBq_container",
  "content": "LmMEBq_content",
  "headline": "LmMEBq_headline",
  "icon": "LmMEBq_icon",
  "section": "LmMEBq_section",
});
